/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useMemo } from 'react';

import { type SkillKeyEnum } from '@coze-agent-ide/tool-config';

/**
 * Used to verify the default expanded and stowed state of the current module
 * @Deprecated change attribute is deprecated and not maintained, please replace the useToolContentBlockDefaultExpand in @code-agent-ide/tool
 * @param blockKey primary key
 * @param configured whether there is configuration content
 * Check when @param
 *
 */
const useDefaultExPandCheck = (
  $params: {
    blockKey: SkillKeyEnum;
    configured: boolean;
  },
  $when = true,
) => {
  const { configured = false } = $params;
  return useMemo(() => {
    // 不参与校验的模块不渲染内容
    if (!$when) {
      return undefined;
    }
    // 有内容则强制默认展开（不再依赖用户历史的展开/收起记录）
    return configured;
  }, [$when, configured]);
};

export { useDefaultExPandCheck };
